'use client';
import { GoArrowLeft } from 'react-icons/go';

const options = [
  { value: 'none', label: 'None' },
  { value: 'some', label: 'Some' },
  { value: 'a_lot', label: 'A lot' },
];

export default function ExperienceStep({ formik, onBack }) {
  return (
    <>
      {/* Back Button */}
      <button
        type="button"
        onClick={onBack}
        className="mb-[0.5rem] flex cursor-pointer items-center gap-[0.5rem] text-[1rem] font-bold text-dark transition-colors hover:text-blue-600 focus:outline-none"
      >
        <GoArrowLeft size={18} />
        <span className="text-base font-semibold">Back</span>
      </button>

      <h2 className="mb-[0.5rem] text-[1.66rem] font-[500] leading-tight text-[#191919]">
        How Much Business Experience Do You Have?
      </h2>

      {/* Experience Options */}
      <div className="mb-[0.5rem] flex flex-col gap-[1rem]">
        {options.map((opt) => (
          <label
            key={opt.value}
            className={`flex w-full cursor-pointer items-center rounded-lg border bg-[#F9FAFB] px-4 py-[0.75rem] text-base font-medium transition-all ${formik.values.experience === opt.value ? 'border-therablue' : 'border-[#E5E7EB]'} ${formik.touched.experience && formik.errors.experience && !formik.values.experience ? 'border-red-500' : ''} `}
          >
            <input
              type="radio"
              name="experience"
              value={opt.value}
              checked={formik.values.experience === opt.value}
              onChange={formik.handleChange}
              className="form-radio mr-[1rem] h-5 w-5 accent-therablue"
            />
            <span className="text-[#191919]">{opt.label}</span>
          </label>
        ))}

        {/* Error Message */}
        {formik.touched.experience && formik.errors.experience && (
          <div className="mt-1 text-sm text-red-500">{formik.errors.experience}</div>
        )}
      </div>
    </>
  );
}
